import { render, staticRenderFns } from "./EmailSenderList.vue?vue&type=template&id=12a853bc&scoped=true&lang=pug&"
import script from "./EmailSenderList.vue?vue&type=script&lang=js&"
export * from "./EmailSenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a853bc",
  null
  
)

export default component.exports